import { useEffect, useState } from "react";
import { Tabs, Tab, Box, useMediaQuery } from "@mui/material";
import Layout from "../../components/Layout";
import Table from "../../components/Table/Table";
import { TableSearch } from "../../components/Table/TableActions";
import PageTitle from "../../components/PageTitle";
import { Icon } from "@iconify/react";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { httprequest } from "../../data/api";

const BulkEmail = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [scheduleData, setScheduleData] = useState([]); // For scheduled emails
  const [outboxData, setOutboxData] = useState([]); // For outbox emails

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /**
   * Fetches bulk email data from the API and updates the state.
   * It filters the emails into scheduled and outbox categories.
   */
  const fetchBulkEmailData = () => {
    httprequest
      .get("/api/v1/bulk-email")
      .then((res) => {
        if (res.data.message === "Emails fetched successfully") {
          const scheduledEmails = res.data.data.filter((email) => email.email_state === "scheduled");
          const outboxEmails = res.data.data.filter((email) => email.email_state === "outbox");

          setScheduleData(scheduledEmails);
          setOutboxData(outboxEmails);
        }
      })
      .catch(() => {
      });
  };

  useEffect(() => {
    fetchBulkEmailData();
  }, []);

  const scheduleColumns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Subject</p>}
          {row.subject}
        </>
      )
    },
    {
      name: "Recipient",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Recipient</p>}
          {row.recipient}
        </>
      )
    },
    {
      name: "Type",
      center: "true",
      selector: (row) => (
        <>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Type</p>}
          {row.type}
        </>
      )
    },
    {
      name: "Scheduled Date",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Scheduled Date</p>}
          {row.schedule_date || "N/A"}
        </>
      )
    },
    {
      name: "Scheduled Time",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Scheduled Time</p>}
          {row.schedule_time || "N/A"}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon">
            <Icon icon="hugeicons:view" />
          </button>
          <button className="table-action-icon">
            <Icon icon="lucide:edit" />
          </button>
          <button className="table-action-icon">
            <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
          </button>
        </div>
      )
    }
  ];

  const outboxColumns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Subject</p>}
          {row.subject}
        </>
      )
    },
    {
      name: "Recipient",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Recipient</p>}
          {row.recipient}
        </>
      )
    },
    {
      name: "Type",
      center: "true",
      selector: (row) => (
        <>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Type</p>}
          {row.type}
        </>
      )
    },
    {
      name: "Date Sent",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Date Sent</p>}
          {new Date(row.created_at).toLocaleDateString()}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon">
            <Icon icon="hugeicons:view" />
          </button>
          <button className="table-action-icon">
            <Icon icon="lucide:edit" />
          </button>
          <button className="table-action-icon">
            <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
          </button>
        </div>
      )
    }
  ];

  return (
    <Layout children={
      <>
        <PageTitle
          title="Send Bulk Emails"
          subtitle="You can send bulk emails here."
          button={
            <Button
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              buttonName="Send Bulk Email"
              onClick={() => navigate("/messaging/sendemails")}
            />
          }
        />
        <div className="page-content">
          <div className="tablist-container">
            <Tabs className="overide-tablist"
              value={value} onChange={handleChange} aria-label="bulk email tabs"
            >
              <Tab label="Schedule" />
              <Tab label="Outbox" />
            </Tabs>
          </div>

          <Box sx={{ marginTop: 2 }}>
            {value === 0 && (
              <div>
                <Table
                  data={scheduleData}
                  columns={scheduleColumns}
                  pagination
                  subHeader={true}
                  subHeaderComponent={
                    <TableSearch
                      placeholder="Search scheduled emails..."
                    />
                  }
                />
              </div>
            )}
            {value === 1 && (
              <div>
                <Table
                  data={outboxData}
                  columns={outboxColumns}
                  pagination
                  subHeader={true}
                  subHeaderComponent={
                    <TableSearch
                      placeholder="Search sent emails..."
                    />
                  }
                />
              </div>
            )}
          </Box>
        </div>
      </>
    }
    />
  );
};

export default BulkEmail;
